// extracted by mini-css-extract-plugin
export var body = "_ex-0";
export var sectionHeader = "_ex-4";
export var shortcutColumns = "_ex-2";
export var shortcutList = "_ex-1";
export var shortcutSection = "_ex-3";